<ng-container *ngIf="embedLogin; else loginViejuno">
  <iframe
    #loginFrame
    class="login-wrapper"
    [src]="loginUrl"
    type="text/javascript"
    sandbox="allow-scripts allow-forms allow-same-origin"
    (load)="onLoginLoad($event)"
  ></iframe>
</ng-container>
<ng-template #loginViejuno>
  <div class="login-container">
    <div class="login-content z-depth-5 padding">
      <div class="row">
        <div class="col s12">
          <ul class="tabs margin-bottom-gap">
            <li class="tab col s12 greylight">
              <a href="#login" class="active">Login</a>
            </li>
          </ul>
        </div>
      </div>
      <form id="login" class="col s12" (ngSubmit)="onSubmit()" #loginForm="ngForm">
        <div class="errorMessage">{{ formErrorMessage }}</div>

        <div class="row">
          <div class="input-field col s12">
            <label for="username">{{ 'auth.username' | translate }}</label>
            <input
              id="username"
              type="text"
              name="username"
              [(ngModel)]="username"
              class="validate"
              required
              autofocus
            />
          </div>

          <div class="input-field col s12">
            <label for="password">{{ 'auth.password' | translate }}</label>
            <input id="password" type="password" name="password" [(ngModel)]="password" class="validate" required />
          </div>

          <div class="col s12 text-centered margin-top-gap margin-bottom">
            <gl-button
              color-primary
              data-testid="submitLoginButton"
              title="{{ 'auth.submit' | translate }}"
              [text]="'auth.submit' | translate"
              [disabled]="loginForm.invalid || loginForm.submitted"
              (onClick)="onSubmit()"
            ></gl-button>
          </div>
        </div>

        <div class="divider"></div>

        <div class="row">
          <div class="col s12">
            <a [routerLink]="['/forgot-password']" title="Reset Password" class="right margin-top-gap">
              {{ 'auth.forgotPassword' | translate }}
            </a>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
